export const getSalesEventTypes = (state) =>
  Object.values(state?.salesEventTypes?.byId ?? [])

export const getSalesEventType = (state, id) =>
  state?.salesEventTypes?.byId[id] ?? {}

export const getIsSalesEventTypeLoading = (state) =>
  state?.salesEventTypes?.isLoading ?? false
